module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/decorator-748b9c8283007ebe6a1040f5965cb676.webp";